import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./LeadDetalhes.css";
import { formatarDataBrasil } from "../utils/utils";

export default function LeadDetalhes() {
  const { lead_id } = useParams();
  const navigate = useNavigate();

  const [lead, setLead] = useState(null);
  const [tags, setTags] = useState([]);
  const [tagsDisponiveis, setTagsDisponiveis] = useState([]);
  const [novaTag, setNovaTag] = useState("");
  const [acoes, setAcoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // força a página inteira a poder rolar enquanto esta tela estiver aberta
    const html = document.documentElement;
    const body = document.body;

    const oldHtmlOverflow = html.style.overflow;
    const oldHtmlHeight = html.style.height;
    const oldBodyOverflow = body.style.overflow;
    const oldBodyHeight = body.style.height;

    html.style.overflow = "auto";
    html.style.height = "auto";
    body.style.overflow = "auto";
    body.style.height = "auto";

    body.classList.add("lead-detalhes-body-scroll");

    return () => {
      html.style.overflow = oldHtmlOverflow;
      html.style.height = oldHtmlHeight;
      body.style.overflow = oldBodyOverflow;
      body.style.height = oldBodyHeight;
      body.classList.remove("lead-detalhes-body-scroll");
    };
  }, []);

  useEffect(() => {
    if (!lead_id) return;

    (async () => {
      try {
        await Promise.all([carregarLead(), carregarTagsDisponiveis()]);
      } finally {
        setLoading(false);
      }
    })();
  }, [lead_id]);

  const carregarLead = async () => {
    try {
      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/lead_detalhado.php?lead_id=${lead_id}`,
        { credentials: "include" }
      );

      const data = await response.json();

      if (data?.lead) {
        setLead(data.lead);
        setAcoes(Array.isArray(data.acoes) ? data.acoes : []);
        setTags(Array.isArray(data.tags) ? data.tags : []);
      } else {
        setLead(null);
        setAcoes([]);
        setTags([]);
      }
    } catch (error) {
      console.error("Erro ao carregar lead:", error);
      setLead(null);
      setAcoes([]);
      setTags([]);
    }
  };

  const carregarTagsDisponiveis = async () => {
    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/tags.php?resumo=1",
        { credentials: "include" }
      );

      const data = await response.json();
      setTagsDisponiveis(Array.isArray(data?.resumo) ? data.resumo : []);
    } catch (error) {
      console.error("Erro ao carregar tags disponíveis:", error);
      setTagsDisponiveis([]);
    }
  };

  const associarTag = async () => {
    if (!novaTag) return;

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/lead_tags.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            lead_id,
            tag_id: Number(novaTag),
          }),
        }
      );

      const data = await response.json();

      if (data?.success) {
        setNovaTag("");
        await carregarLead();
      } else {
        alert(data?.message || "Erro ao associar tag.");
      }
    } catch (error) {
      console.error("Erro ao associar tag:", error);
    }
  };

  const removerTag = async (tagId) => {
    if (!window.confirm("Remover esta tag do lead?")) return;

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/lead_tags.php",
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            lead_id,
            tag_id: Number(tagId),
          }),
        }
      );

      const data = await response.json();

      if (data?.success) {
        await carregarLead();
      } else {
        alert(data?.message || "Erro ao remover tag.");
      }
    } catch (error) {
      console.error("Erro ao remover tag:", error);
    }
  };

  const formatarTelefoneVisao = (telefone = "") => {
    if (!telefone.startsWith("55")) return telefone;

    if (telefone.length === 13) {
      return telefone.replace(/^55(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    }

    return telefone.replace(/^55(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  };

  return (
    <div className="lead-detalhes-root">
      <div className="lead-detalhes-page">
        <div className="lead-detalhes-content">
          <h1 className="h1-detalhes">Detalhes do Lead</h1>

          <div className="lead-detalhes-container">
            {loading ? (
              <p className="carregando">Carregando detalhes do lead...</p>
            ) : lead ? (
              <>
                <div className="lead-info-wrapper">
                  <div className="lead-info">
                    <p>
                      <strong>Nome:</strong> {lead.nome}
                    </p>

                    <p>
                      <strong>Telefone:</strong>{" "}
                      {formatarTelefoneVisao(lead.telefone)}
                    </p>

                    <Link
                      to={`/wzp/painel-mensagens?telefone=${encodeURIComponent(
                        lead.telefone
                      )}&leadId=${lead.id}`}
                      className="btn-whatsapp"
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                        alt="WhatsApp"
                      />
                      Enviar Mensagem
                    </Link>

                    <p>
                      <strong>Origem do Lead:</strong> {lead.origem_lead}
                    </p>

                    <p>
                      <strong>Interesse:</strong> {lead.interesse}
                    </p>

                    <p>
                      <strong>Data do Primeiro Contato:</strong>{" "}
                      {formatarDataBrasil(lead.data_primeiro_contato)}
                    </p>

                    <p>
                      <strong>Estágio do Funil:</strong> {lead.estagio_funil}
                    </p>

                    <p>
                      <strong>Observação:</strong> {lead.observacao}
                    </p>
                  </div>

                  <div className="lead-foto-wrapper">
                    <img
                      src={
                        lead.foto ||
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                      }
                      alt="Foto do contato"
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                      }}
                    />
                  </div>
                </div>

                <h3 className="lead-detalhes-subtitulo">Tags Associadas</h3>

                {tags.length > 0 ? (
                  <ul className="lead-tags-list">
  {tags.map((tag) => (
    <li key={tag.id} className="lead-tag">
      <span className="lead-tag-nome">{tag.nome}</span>

      <button
        type="button"
        className="btn-remover-tag"
        onClick={() => removerTag(tag.id)}
        title="Remover tag"
      >
        ❌
      </button>
    </li>
  ))}
</ul>
                ) : (
                  <p className="nenhuma-tag">
                    Este lead ainda não possui tags.
                  </p>
                )}

                <div className="adicionar-tag-container">
                  <select
                    value={novaTag}
                    onChange={(e) => setNovaTag(e.target.value)}
                    className="tag-select"
                  >
                    <option value="">Selecione uma Tag</option>
                    {tagsDisponiveis
                      .filter((td) => !tags.some((t) => t.id === td.id))
                      .map((tag) => (
                        <option key={tag.id} value={tag.id}>
                          {tag.nome}
                        </option>
                      ))}
                  </select>

                  <button
                    type="button"
                    className="btn-adicionar-tag"
                    onClick={associarTag}
                    disabled={!novaTag}
                  >
                    Adicionar
                  </button>
                </div>

                <h3 className="lead-detalhes-subtitulo">Histórico de Ações</h3>

                {acoes.length > 0 ? (
                  <div className="acoes-table-wrapper">
                    <table className="acoes-table">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                          <th>Data da Ação</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {acoes.map((acao) => (
                          <tr key={acao.id}>
                            <td>{acao.descricao}</td>
                            <td>{formatarDataBrasil(acao.data_acao)}</td>
                            <td>{acao.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="nenhuma-tag">
                    Este lead ainda não possui ações registradas.
                  </p>
                )}

                <div className="botoes-lead-detalhes">
                  <Link to={`/editar-lead/${lead.id}`} className="btn-editar">
                    Editar Lead
                  </Link>

                  <button
                    type="button"
                    className="btn-voltar"
                    onClick={() => {
                      navigate("/listagem-leads", { replace: true });
                      window.location.reload();
                    }}
                  >
                    Voltar
                  </button>
                </div>
              </>
            ) : (
              <p className="carregando">Lead não encontrado.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}